import { Input, InputWrapperProps, NumberInput, NumberInputProps } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { useFormHelperContext } from "../form";
import { useController, useFormState } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";
import { useDebounce } from "use-debounce";

export interface FieldInputNumberProps extends NumberInputProps {
    label: string;
    name: string;
    min: number;
    max?: number;
    inputWrapper?: InputWrapperProps;
    debounce?: boolean
}

export const FieldInputNumber: React.FC<FieldInputNumberProps> = ({ label, debounce, name, placeholder, inputWrapper, min, max, readOnly, ...rest }) => {
    const { control, formStore, setValue } = useFormHelperContext();
    const { field, fieldState: { error } } = useController({ name, control });

    const [numValue, setNumValue] = useState(0)
    const [value] = useDebounce(numValue, 500);


    useEffect(() => {
        if (debounce) {
            setValue(name, value)
        }
    }, [value])

    const handleOnChange = (value: string | number) => {
        setNumValue(typeof value === 'string' ? parseFloat(value) : value)
    }
    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <NumberInput
                    {...field}
                    onChange={debounce ? handleOnChange : field.onChange}
                    readOnly={readOnly ?? formStore.readOnly}
                    inputContainer={(children) => (
                        <div className="flex flex-col w-full">
                            {children}
                        </div>
                    )}
                    data-testid={'field-number-' + name}
                    min={min}
                    max={max}
                    {...rest}
                />
                {error && <Input.Error>{error.message}</Input.Error>}
            </div>
        </InputWrapper>
    );
};
